module.exports = __webpack_public_path__ + "static/media/DSC_2494.06fd582d.jpg";